export default __webpack_public_path__ + "static/graphik-web-super-b8d1788569af664ee812c754f454cab3.woff";